import { Alert } from 'antd';
import React from 'react';

type ErrorMessageProps = {
  message: string;
  header?: string;
  onDismiss?: () => void;
};
function ErrorMessage(props: ErrorMessageProps) {
  return (
    <Alert
      type='error'
      showIcon
      onClose={props.onDismiss}
      closable
      message={props.header ? props.header : 'Villa í greiningu!'}
      description={<p>{props.message}</p>}
    />
  );
}

export default ErrorMessage;
